import { render, staticRenderFns } from "./InsurerUsersShowPage.vue?vue&type=template&id=79814e53&"
import script from "./InsurerUsersShowPage.vue?vue&type=script&lang=js&"
export * from "./InsurerUsersShowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports